import { useState, useEffect } from 'react'

export const useRefresh = ({
  refreshInterval = 10 * 60 * 1000, // 10 min
  remountInterval = 3000, // 3 sec
  maxRefreshes = 10,
  disabled = false,
}) => {
  const [isRefreshed, setIsRefresh] = useState(true)
  const [refreshCount, setRefreshCount] = useState(0)

  useEffect(() => {
    if (disabled) return undefined
    let interval
    if (refreshCount === maxRefreshes) {
      return undefined
    }
    if (isRefreshed) {
      interval = setInterval(() => {
        setIsRefresh(false)
        setRefreshCount(count => count + 1)
      }, refreshInterval)
    }
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [disabled, isRefreshed, maxRefreshes, refreshCount, refreshInterval])

  useEffect(() => {
    if (disabled) return undefined
    let timeout
    if (!isRefreshed) {
      timeout = setTimeout(() => {
        setIsRefresh(true)
      }, remountInterval)
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [disabled, isRefreshed, remountInterval])

  return {
    isRefreshed,
    refreshCount,
  }
}
